import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Page } from '../../components';
import Box from '../../components/layout/Box';
import Button from '../../components/widgets/Button';

import PermissionModal from '../../components/widgets/PermissionModal';

import { Icon } from '../../components/widgets';

import { GrapejsEditor } from '../../components';
import { Link } from 'react-router-dom';

import {
  fetchCustomTemplates, setPageTitle, uploadAsset
} from 'signoxe/actions';

import {
  getUsers, isFetching, getCustomTemplates
} from 'signoxe/selectors';

import 'grapesjs/dist/css/grapes.min.css';
import grapesjs from 'grapesjs';

import './styles.scss';

import _ from 'lodash';

class HtmlEditorPage extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      selected: null,
      html: ''
    }
  }

  componentDidMount(){
    console.log(this.props)
    // this.props.fetchCustomTemplates()
    this.props.setPageTitle('Add Zip asset')

    const location = this.props.location.search;
    const searchParams = new window.URLSearchParams(location)

    if (searchParams.has("template")){
      const data = this.props.templates[searchParams.get("template")]

      const html = data ? data.template : ''

      this.setState({ html, selected: searchParams.get("template") })
    }
  }

  handleContentChange(){
    console.log('Changed grapejs editor')
  }

  handleTemplateChange(e){
    const selected = e.target.selectedOptions[0].value;
    const data = this.props.templates[selected]

    const html = data ? data.template : ''

    this.setState({html, selected})
  }

  render() {
    const { templates } = this.props;

    const { selected } = this.state;

    return (
      <Page className="main-page">
         <select id="template-selector" value={selected} onChange={(e)=>this.handleTemplateChange(e)} name="template-selector">
          <option value="NULL" key="null">Select Template</option>
          {templates.map(template =>
            (<option key={template.id}
                     value={template.id}>{template.name}</option>),
          )}
        </select>

        <GrapejsEditor
          current={selected}
          templates={templates}
          onChange={this.handleContentChange}
          upload={this.props.uploadAsset}
        />

      </Page>
    );
  }
}

export default connect((state, props) => {
    return {
        templates: getCustomTemplates(state)
        // isFetching: isFetching(state)
    };
  },
  {
    fetchCustomTemplates, setPageTitle,
    uploadAsset
  },
)(HtmlEditorPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/HtmlEditorPage/index.js